import { ModelBase } from 'store/model-base';
import { PaymentState } from 'my-account/constants';

export class SsmStatementSnapshot extends ModelBase {
    public static storeName: string = 'ssmStatementSnapshot';

    public statementDate: string;
    public cycleRange: string;
    public amount: string;
    public docId: number;
    public status: string;
    public statementSource: string;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        if (data?.status === 'PASTDUE') {
            data.status = PaymentState.PAST_DUE;
        }

        return super.create<T>(data);
    }
}
